import Image from 'src/components/image';
import { Stack, Typography, Button } from '@mui/material';
import PropTypes from 'prop-types';

export default function ErrorBoundaryFallback({ error, resetErrorBoundary }) {
  // functions
  const handleGoHome = () => {
    window.location.reload();
  };

  return (
    <Stack spacing="16px" alignItems="center" height="100%" width="100%">
      <Image
        src="/assets/illustrations/error-boundary.svg"
        sx={{
          width: '50%',
        }}
        alt="error-boundary-illustration"
      />
      <Stack alignItems="center">
        <Typography variant="h1">Oops!!</Typography>
        <Typography variant="h1">Something went wrong</Typography>
      </Stack>
      <Button
        onClick={handleGoHome}
        variant="contained"
        sx={{
          width: '50%',
        }}
      >
        Go Home
      </Button>
    </Stack>
  );
}

ErrorBoundaryFallback.propTypes = {
  error: PropTypes.object,
  resetErrorBoundary: PropTypes.func,
};
